export enum AdminDomainType {
  ADMIN_USER = 'ADMIN_USER',
}
